'use strict';

var FetchMock = require('./lib/index');
var statusTextMap = require('./lib/status-text');
var theGlobal = typeof window !== 'undefined' ? window : self;

FetchMock.global = theGlobal;
FetchMock.statusTextMap = statusTextMap;

FetchMock.config = Object.assign(FetchMock.config, {
	Promise: theGlobal.Promise,
	Request: theGlobal.Request,
	Response: theGlobal.Response,
	Headers: theGlobal.Headers
});

module.exports = FetchMock.createInstance();


//////////////////
// WEBPACK FOOTER
// ./node_modules/fetch-mock-es5/es5/client.js
// module id = 1719
// module chunks = 0